import { clsx } from "clsx";
import type { CSSProperties, FC, PropsWithChildren } from "react";

import style from "./Stack.module.css";

export interface CenterProps {
  className?: string;
  style?: CSSProperties;
  padding?: CSSProperties["padding"];
  width?: CSSProperties["width"];
  height?: CSSProperties["height"];
}

export const Center: FC<PropsWithChildren<CenterProps>> = (props) => {
  return (
    <div
      data-testid="center"
      className={clsx(style.center, props.className)}
      style={{
        width: props.width,
        height: props.height,
        padding: props.padding,
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};
